import React from 'react';

import {
    withStyles,
    ListItem,
    Grid,
    ListItemText,
    Typography,
    Button,
    ButtonBase,
    Snackbar,
    Divider,
} from '@material-ui/core';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import MSnackbar from '../view/MSnackbar';
import MBack from '../view/MBack';
import Cancel from '@material-ui/icons/Cancel'
import DeviceEventEmitter, { EventName } from '../../control/event';

class SelfInfoDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nickname: AppData.me.Username,
            snackopened: false,
            message: '',
        };
        this._saveInfo = this._saveInfo.bind(this);
        this._onCancel = this._onCancel.bind(this);
    }

    _saveInfo() {
        const { nickname } = this.state;
        if (!nickname || nickname === '') {
            this.setState({ message: '昵称不能为空', snackopened: true });
            return;
        }
        this._onChangeName();
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }


    _onCancel() {
        this.setState({ nickname: '' });
    }

    _onChangeName = async () => { 
        // IMApp.msg_set_name(this.state.nickname)
        let result = await Apis.encryptionEditName(this.state.nickname, AppData.me.customer_id, AppData.me.token);
        console.log('_onChangeName', result);
        if (result.code == 200) {
            AppData.me.Username = this.state.nickname;
            this.toast.show("修改成功");
            
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        } else {
            this.toast.show(result.msg);
        }
    }

    // 个人信息
    render() {
        const { classes } = this.props;
        const { nickname, snackopened, message } = this.state;
        return (
            <MBack title="昵称修改">
                <Grid style={{ height: 16 }}></Grid>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45, paddingLeft: 0 }}>
                    <input
                        onChange={event => this.setState({ nickname: event.target.value })}
                        value={nickname}
                        type='text'
                        className={classes.textfield}
                        placeholder='输入昵称'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                        paddingRight: 0
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', fontSize: 15 }}></Cancel>
                    </Button>
                </ListItem>
                <Grid style={{ height: 8 }}></Grid>
                <Divider light style={{ background: '#E2E2E2', width: 'calc(100vw - 32px)', marginLeft: 16, justifyContent: 'center' }} />
                <Grid style={{ height: 8 }}></Grid>
                <ListItemText primary={<Typography style={{ color: '#878787', fontSize: 11, marginLeft: 16 }}>1.昵称1天内只可修改一次,不得超过10个字符。</Typography>} />
                <ListItemText primary={<Typography style={{ color: '#878787', fontSize: 11, marginLeft: 16, marginTop: 8 }}>2.昵称只允许输入中英文、数字及符号-、[]。</Typography>} />
                <ListItemText primary={<Typography style={{ color: '#878787', fontSize: 11, marginLeft: 16, marginTop: 8 }}>3.昵称修改成功后,若经人工审核违规将被重置。</Typography>} />
                <Grid container justify='center' >
                    <ButtonBase
                        className={classes.loginBtn}
                        onClick={this._saveInfo}
                    >确认</ButtonBase>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
                <MSnackbar ref={(ref) => { this.toast = ref }} />
            </MBack>
        );
    }
}

export default withStyles((theme) => ({
    loginBtn: {
        background: '#007AFF',
        borderRadius: 10,
        color: 'white',
        height: 45,
        width: "calc(100vw - 32px)",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    textfield: {
        backgroundColor: 'transparent',
        fontSize: 13,
        height: 30,
        marginLeft: 10,
        borderRadius: 10,
        width: '90%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(1, 1, 1, 1),
    },
}))(SelfInfoDialog);